<div />

<style>
  :global(body) {
    overscroll-behavior-x: none;
  }
</style>
